import "./SuggestedAgendaItemsPanel.scss";

import { EditFormLabel } from "components/Forms/EditFormLabel";
import { InlineSpinner } from "components/InlineSpinner";
import { SlidingPanel } from "components/SlidingPanel/SlidingPanel";
import { ResourceKeys, useSuggestedAgendaItemPanel } from "providers";
import { useTranslations } from "providers";
import React from "react";

import { SuggestedAgendaItemsForm } from "./SuggestedAgendaItemsForm";
import { SuggestedAgendaItemsPanelFooter } from "./SuggestedAgendaItemsPanelFooter";

export const SuggestedAgendaItemsPanel: React.FC = () => {
  const i18n = useTranslations();

  const { isOpen, isLoading, isSubmitting, isDeleting, isForm, submitMessage, setFilterText, closePanel } =
    useSuggestedAgendaItemPanel();

  if (!isOpen) {
    return null;
  }

  return (
    <SlidingPanel
      isOpen
      onClose={() => closePanel()}
      onCancel={() => closePanel()}
      panelClassName="suggested-agenda-items"
      header={<h1>{i18n.SuggestedAgendaItemsPanel_Header}</h1>}
      footer={<SuggestedAgendaItemsPanelFooter />}
    >
      <>
        {submitMessage && <div>{submitMessage}</div>}

        {isLoading && <InlineSpinner text={i18n.SuggestedAgendaItems_Loading} />}
        {isSubmitting && <InlineSpinner text={i18n.SuggestedAgendaItems_Submitting} />}
        {isDeleting && <InlineSpinner text={i18n.SuggestedAgendaItems_Deleting} />}
        {isForm && (
          <>
            <div>
              <EditFormLabel label={ResourceKeys.SuggestedAgendaItems_Filter} />
              <input type="text" className="form-control" onChange={(e) => setFilterText(e.target.value)} />
            </div>
            <div>
              <SuggestedAgendaItemsForm />
            </div>
          </>
        )}
      </>
    </SlidingPanel>
  );
};
